module.exports = __webpack_public_path__ + "static/media/a.icon.transparent.b5f2e461.png";